import Swiper, { Navigation, Autoplay, FreeMode, Scrollbar, Mousewheel } from 'swiper'

const StepByStep = () => {
  const swiper = new Swiper('.step-by-step-slider', {
    modules: [Autoplay, Navigation, FreeMode, Scrollbar, Mousewheel],
    
    direction: 'vertical',
    slideToClickedSlide: true,
    mousewheel: true,
    slidesOffsetAfter: 50,
    
    // updateOnWindowResize: true,
    // autoHeight: true,
    
    navigation: {
      nextEl: '.step-by-step-block .slider-button-next',
      prevEl: '.step-by-step-block .slider-button-prev',
    },

    breakpoints: {
      0: {
        slidesPerView: 'auto',
      },
      1024: {
        slidesPerView: 'auto',
      },
    },

    // on: {
    //   snapGridLengthChange:function(){
    //     if( this.snapGrid.length != this.slidesGrid.length ){
    //       this.snapGrid = this.slidesGrid.slice(0);
    //     }
    //   },
    //   slideChangeTransitionEnd:function(s){
    //     s.update();
    //   }
    // }
  })

}

export default StepByStep
